"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EActiveFlow = void 0;
let EActiveFlow = exports.EActiveFlow = /*#__PURE__*/function (EActiveFlow) {
  EActiveFlow["Authentication"] = "authentication";
  EActiveFlow["Registration"] = "registration";
  return EActiveFlow;
}({});